import Axios from 'axios'
import { getErrorMessage, STDIZER_URL } from '@/main'

const state = {
  stateStdizerResult: null,
  stdizerBuildDate: null,
}

const getters = {
  stdizerResult: (state) => {
    return state.stateStdizerResult
  },
}

const mutations = {
  setStdizerResult: (state, payload) => {
    state.stateStdizerResult = payload
  },
  resetStdizerResult: (state) => {
    state.stateStdizerResult = null
  },
}

const actions = {}

export function prepareStdizerMetadata(context) {
  Axios.get(`${STDIZER_URL}/metadata`)
    .then((response) => {
      context.commit('setFeatures', { stdizer: { category: 'module' } })
    })
    .catch((error) => {
      console.warn('STDIZER module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { stdizer: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
